import styled from 'styled-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const ModalRoot = styled.div``

export const ModalContainer = styled.div<{
    extraWidth: string
    enableOverflow: boolean
}>`
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 150;
    padding: 1em 1.5em 1.5em;
    background-color: white;
    border-radius: 5px;
    width: ${({ extraWidth }) => (extraWidth ? extraWidth : null)};
    overflow: ${({ enableOverflow }) => (enableOverflow ? 'auto' : 'hidden')};

    // mobile
    @media (max-width: 550px) {
      transition: all 0.2s ease 0s;
      min-width: 412px !important;
      left: 0px !important; 
      width: calc(60% - 80px)!important;
      transform: none !important;
      top: unset !important;
      z-index: 150 !important; 
      overflow: auto !important;
      bottom: 74px !important;
      max-height: 793px !important;
      padding-right: 56px;
      padding-left: 56px;
      height: calc(91% - 46px)!important;
    }
    }
`

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
`

export const ModalContent = styled.div``

export const ModalCloseIcon = styled(FontAwesomeIcon)`
    color: #005cdb;
    &:hover {
        cursor: pointer;
        color: #2164db;
    }
`

export const ModalTitle = styled.h1`
    text-align: center;
    font-size: 1.75em;
    font-weight: 400;
    margin: 0 0 0.3em 0.5em;
    line-height: 1.2;
`

export const BackgroundBlur = styled.div`
    position: fixed;
    z-index: 100;
    width: 102vw;
    left: -1vw;
    height: 102vh;
    top: -1vh;
    background-color: black;
    opacity: 0.8;
`
